import utils from "@/utils";
import moment from "moment";

/* cache object on demand */
const cache = {
  store: null,
  async tryGet(getterAction, timeout) {
    timeout = !timeout ? 1000 : timeout;

    const iterations = Math.ceil(timeout / 100);
    for (let i = 0; i < iterations; i++) {
      const obj = getterAction();
      if (obj) {
        return obj;
      }

      await utils.sleep(100);
    }

    return null;
  },
  clear() {
    this.users.map.clear();
    this.events.map.clear();
    this.boards.map.clear();
    this.lists.map.clear();
    this.cards.map.clear();
    this.boardFieldsTxt.map.clear();
    this.boardFieldsInt.map.clear();
    this.alarms.map.clear();
    this.botRiotLists.map.clear();
  },
  users: {
    map: new Map(),
    byId: function(id) {
      let user = this.map.get(id);
      if (user) return user;

      user = cache.store.state.users.all.find(b => b.id == id);
      if (!user && id == cache.store.state.users.active.id) {
        user = Object.assign({}, cache.store.state.users.active);
      }

      if (user) {
        this.map.set(id, user);
      }
      return user;
    }
  },
  events: {
    map: new Map(),
    tryAdd: function(event) {
      if (this.map.get(event.id)) return false;

      this.map.set(event.id, event);
      return true;
    },
    byId: function(id) {
      return this.map.get(id);
    }
  },
  boards: {
    map: new Map(),
    firstOrDefault(condition) {
      let board;
      let result;
      const all = cache.store.state.boards.all;
      for (let i = 0; i < all.length; i++) {
        board = all[i];
        result = condition(board);
        if (result) {
          if (typeof result == "boolean") return board;
          return result;
        }
      }
      const archived = cache.store.state.boards.archived;
      for (let i = 0; i < archived.length; i++) {
        board = archived[i];
        result = condition(board);
        if (result) {
          if (typeof result == "boolean") return board;
          return result;
        }
      }

      return null;
    },
    tryAdd: function(board) {
      if (this.map.get(board.id)) return false;

      this.setup(board);
      this.map.set(board.id, board);

      board.lists.forEach(l => cache.lists.tryAdd(l));

      return true;
    },
    byId: function(id) {
      return this.map.get(id);
    },
    /** если нет данных, то будет ждать */
    byIdAsync: async function(id, timeout) {
      timeout = !timeout ? 1000 : timeout;

      const iterations = Math.ceil(timeout / 100);
      for (let i = 0; i < iterations; i++) {
        let board = this.map.get(id);
        if (board) {
          return board;
        }

        await utils.sleep(100);
      }

      return null;
    },
    setup(board) {
      if (!board) return;

      if (!board.id) {
        console.error("Cant add board without id", board);
        return;
      }

      board.type = "board";
      if (!board.archived) board.archived = false;
      if (!board.isArchiveLoaded) board.isArchiveLoaded = false;
      if (!board.lists) board.lists = [];
      if (!board.fields) board.fields = [];
      if (!board.fieldsTxt) board.fieldsTxt = [];
      if (!board.archive) board.archive = {};
      if (!board.archive.cards) board.archive.cards = [];
      if (!board.archive.lists) board.archive.lists = [];
      if (!board.hasBoardOrder) board.hasBoardOrder = false;

      if (!board.users) board.users = [];
      if (!board.creator) board.creator = null;
    }
  },
  lists: {
    map: new Map(),
    firstOrDefault(condition) {
      return cache.boards.firstOrDefault(b => {
        let list;
        let result;
        for (let i = 0; i < b.lists.length; i++) {
          list = b.lists[i];

          result = condition(list);
          if (result) {
            if (typeof result == "boolean") return list;
            return result;
          }
        }
        for (let i = 0; i < b.archive.lists.length; i++) {
          list = b.archive.lists[i];

          result = condition(list);
          if (result) {
            if (typeof result == "boolean") return list;
            return result;
          }
        }
        return null;
      });
    },
    tryAdd: function(list) {
      if (this.map.get(list.id)) return false;

      this.setup(list);
      this.map.set(list.id, list);

      list.cards.forEach(c => cache.cards.tryAdd(c));

      return true;
    },
    byId: function(id) {
      return this.map.get(id);
    },
    setup(list) {
      if (!list) return;

      if (!list.id) {
        console.error("Cant add list without id", list);
        return;
      }

      list.type = "list";

      if (!list.archived) list.archived = false;
      if (!list.cards) list.cards = [];
      if (!list.alarms) list.alarms = [];
      if (!list.botRiotLists) list.botRiotLists = [];
    }
  },
  cards: {
    map: new Map(),
    firstOrDefault(condition) {
      let resultCard = cache.lists.firstOrDefault(l => {
        let card;
        let result;
        for (let i = 0; i < l.cards.length; i++) {
          card = l.cards[i];

          result = condition(card);
          if (result) {
            if (typeof result == "boolean") return card;
            return result;
          }
        }
        return null;
      });
      if (resultCard) return resultCard;

      return cache.boards.firstOrDefault(b => {
        let card;
        let result;
        for (let i = 0; i < b.archive.cards.length; i++) {
          card = b.archive.cards[i];

          result = condition(card);
          if (result) {
            if (typeof result == "boolean") return card;
            return result;
          }
        }
        return null;
      });
    },
    byInBoardId: function(boardId, inBoardId) {
      return this.map.get(boardId + "_" + inBoardId);
      /*
      const key = boardId + "_" + inBoardId;
      let card = this.map.get(key);
      if (card) return card;

      card = this.firstOrDefault(c => c.board_id == boardId && c.in_board_id == inBoardId);
      if (card) {
        this.map.set(key, card);
      }

      return card;*/
    },
    tryAdd: function(card) {
      if (this.map.get(card.id)) return false;

      this.setup(card);
      this.map.set(card.id, card);
      this.map.set(card.board_id + "_" + card.in_board_id, card);

      return true;
    },
    byId: function(id) {
      return this.map.get(id);
    },
    setup(card) {
      if (!card) return;

      if (!card.id) {
        console.error("Cant add card without id", card);
        return;
      }

      card.type = "card";

      if (!card.description) card.description = "";
      if (!card.events) card.events = [];
      if (!card.fields) card.fields = [];
      if (!card.fieldsTxt) card.fieldsTxt = [];
      if (!card.messages) card.messages = [];
      if (!card.files) card.files = [];
      if (!card.uploadingFiles) card.uploadingFiles = [];
      if (!card.alarms) card.alarms = [];

      card.moment = moment(card.date);
    }
  },
  boardFieldsTxt: {
    map: new Map(),
    byId: function(id) {
      let boardField = this.map.get(id);
      if (boardField) return boardField;

      const boardFields = cache.store.state.boards.all.map(b => b.fieldsTxt).flat(1);
      boardField = boardFields.find(c => c.id == id);
      if (boardField) {
        this.map.set(id, boardField);
      }
      return boardField;
    }
  },
  boardFieldsInt: {
    map: new Map(),
    byId: function(id) {
      let boardField = this.map.get(id);
      if (boardField) return boardField;

      const boardFields = cache.store.state.boards.all.map(b => b.fields).flat(1);
      boardField = boardFields.find(c => c.id == id);
      if (boardField) {
        this.map.set(id, boardField);
      }
      return boardField;
    }
  },
  alarms: {
    map: new Map(),
    byId: function(id) {
      let alarm = this.map.get(id);
      if (alarm) return alarm;

      const alarms = cache.store.state.boards.all
        .map(b => b.lists)
        .flat(1)
        .map(l => l.alarms)
        .flat(1);

      alarm = alarms.find(c => c.id == id);
      if (alarm) {
        this.map.set(id, alarm);
      }
      return alarm;
    }
  },
  botRiotLists: {
    map: new Map(),
    byId: function(id) {
      let botRiotList = this.map.get(id);
      if (botRiotList) return botRiotList;

      const botRiotLists = cache.store.state.boards.all
        .map(b => b.lists)
        .flat(1)
        .map(l => l.botRiotLists)
        .flat(1);

      botRiotList = botRiotLists.find(c => c.id == id);
      if (botRiotList) {
        this.map.set(id, botRiotList);
      }
      return botRiotList;
    }
  },
  push(payload) {
    if (!payload) return;
  }
};

export default cache;
